import { useEffect, useState, useCallback } from 'react';

const VISIBILITY_PERCENT = 0.8;

const buildThresholdList = (size = 10) => {
  const thresholdList = [0];
  for (let i = 1; i <= size; i++) {
    thresholdList.push(Number((size * (i / (size * size))).toFixed(2)));
  }
  return thresholdList;
}

export const useIntersection = (target) => {
  const [isIntersecting, setIsIntersecting] = useState(false);
  const [intersectionRatio, setIntersectionRatio] = useState(false);

  const handleIntersection = useCallback((entries) => {
    const { boundingClientRect, rootBounds, isIntersecting, intersectionRatio} = entries[0];

    if (boundingClientRect.height > rootBounds.height) {
      const heightRatio = Math.ceil(boundingClientRect.height / rootBounds.height);
      setIsIntersecting(isIntersecting && intersectionRatio > VISIBILITY_PERCENT / heightRatio);
    } else {
      setIsIntersecting(isIntersecting && boundingClientRect.top < rootBounds.height / 2);
    }
    setIntersectionRatio(intersectionRatio);
  }, []);

  useEffect(() => {
    const element = target.current;
    if (!element) return;

    const observer = new IntersectionObserver(handleIntersection, { threshold: buildThresholdList() });
    observer.observe(element);

    return () => {
      observer.unobserve(element);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return [isIntersecting, intersectionRatio];
};
